import React from 'react';
import { Loading } from '@roo/roo';
import { Layout } from './_components/Layout';
import { Provider, useSimpleContext } from './_context';
import { useData } from './_context/useData';

const Apply = (props) => {
  const { state } = useSimpleContext((t) => [t.formType, t.loading]);
  useData();

  if (state.loading) {
    return <Loading backdrop fullscreen visible={state.loading} />;
  }

  return <Layout projectNo={props.projectNo} className={state.isViewType ? 'viewType' : ''}>{props.children}</Layout>;
};

export const ApplyViewPage = (props) => {
  if (!props.projectNo) {
    return null;
  }
  return (
    <Provider
      value={{
        isViewType: true,
        disabled: true,
        projectNo: props?.projectNo,
        formType: props?.projectType === 1 ? 'scientist' : 'innovate',
      }}
    >
      <Apply projectNo={props.projectNo}>{props.children}</Apply>
    </Provider>
  );
};
export default (props) => {
  if (!props.projectNo) {
    return null;
  }
  return (
    <Provider
      value={{
        isViewType: true,
        disabled: true,
        // projectNo: props?.projectNo,
        // formType: props?.projectType === 1 ? 'scientist' : 'innovate',
      }}
    >
      <Apply />
    </Provider>
  );
};
